function buildIncrementNumberPattern(prefix: string): RegExp {
  const escapedPrefix = prefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

  return new RegExp(`^${escapedPrefix}-(\\d+)$`)
}

export function computeNextIncrementNumber(entries: { formData?: Record<string, any> }[], key: string, prefix: string, padLength = 2): string {
  const pattern = buildIncrementNumberPattern(prefix)
  let maxNum = 0

  for (const entry of entries) {
    const value = entry?.formData?.[key]

    if (typeof value !== 'string') {
      continue
    }

    const match = value.match(pattern)

    if (!match) {
      continue
    }

    const num = parseInt(match[1], 10)

    if (!Number.isNaN(num) && num > maxNum) {
      maxNum = num
    }
  }

  return `${prefix}-${String(maxNum + 1).padStart(padLength, '0')}`
}

export function hasMissingIncrementNumber(entries: { formData?: Record<string, any> }[], key: string, prefix: string): boolean {
  const pattern = buildIncrementNumberPattern(prefix)

  return entries.some((entry) => {
    const value = entry?.formData?.[key]

    return typeof value !== 'string' || !pattern.test(value)
  })
}
